var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgConexaoCertificadaSebraeLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33.712,
    height: 23.771,
    viewBox: "0 0 33.712 23.771",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ccs2a{isolation:isolate;}.ccs2b{fill:#006ec7;}.ccs2c{fill:url(#abaa);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "abaa",
    x1: 3.856,
    y1: -5.225,
    x2: 4.685,
    y2: -5.225,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b9f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006ec7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-633.571 -929.864)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ccs2a",
    transform: "translate(633.571 929.864)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ccs2b",
    d: "M374.179,571.977a3.08,3.08,0,0,1-2.183-.9,13.395,13.395,0,0,1,18.943-18.943l5.08,5.081a3.087,3.087,0,0,1-4.366,4.366l-5.08-5.08a7.219,7.219,0,0,0-10.21,10.209,3.088,3.088,0,0,1-2.183,5.271Z",
    transform: "translate(-368.072 -548.207)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(643.483 932.897)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ccs2c",
    d: "M106.953,214.234a3.48,3.48,0,0,0,4.921,0l11.918-11.918a3.48,3.48,0,1,1,4.922,4.921L116.8,219.155a3.48,3.48,0,0,1-4.921,0Z",
    transform: "translate(-105.934 -201.296)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ccs2b",
    d: "M107.583,238.771a3.48,3.48,0,1,0,0,4.921l2.461-2.461Z",
    transform: "translate(-101.642 -230.754)"
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgConexaoCertificadaSebraeLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/conexao-certificada-sebrae-logo.58ad219b.svg";
export { ForwardRef as ReactComponent };